import "./index.scss";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

import AddTextModal from "./components/Modals/AddTextModal";
import AddPlayerToTeamModal from "./components/Modals/AddPlayerToTeamModal";
import AssignAssistantModal from './components/Modals/AssignAssistantModal';
import Autocomplete from "./components/UserInputs/Autocomplete";
import BackButtonArrow from './components/Buttons/BackButtonArrow';
import Bars from "./components/Bars";
import BreakdownsBottomPanel from './components/BreakdownsBottomPanel';
import Carousel from "./components/Carousel/Carousel";
import CategoryLoader from "./components/CategoryLoader";
import CircleProgressBar from "./components/ProgressBars/CircleProgressBar";
import Checkbox from "./components/UserInputs/Checkbox";
import CoachTile from './components/CoachTile';
import ComparisonTable from "./components/ComparisonTable";
import ConfirmModal from "./components/Modals/ConfirmModal";
import ConnectWithFacebook from "./components/Buttons/ConnectWithFacebook";
import ClickOutside from "./components/ClickOutside";
import Counter from "./components/Counter";
import CustomAutocomplete from './components/UserInputs/CustomAutocomplete';
import CustomPie from "./components/CustomPie";
import DarkScreenMask from './components/Modals/DarkScreenMask';
import DatePicker from "./components/UserInputs/DatePicker";
import DeleteVideoModal from './components/Modals/DeleteVideoModal';
import DetailInput from "./components/UserInputs/DetailInput";
import DesktopFilterModal from "./components/Modals/DesktopFilterModal";
import DismissButton from "./components/Buttons/DismissButton";
import DotLoader from './components/Loaders/DotLoader';
import Dots from './components/Dots';
import DownloadVideoModal from './components/Modals/DownloadVideoModal';
import Dropdown from './components/UserInputs/Dropdown';
import DropdownWrapper from "./components/DropdownWrapper";
import DynamicPlayerBadge from './components/DynamicPlayerBadge';
import EditHighlightHeader from "./components/EditHighlightHeader/EditHighlightHeader";
import EmptyHighlights from "./components/EmptyHighlights";
import EmptyPlayerProfile from "./components/EmptyPlayerProfile";
import EmptyTeamChannel from "./components/EmptyTeamChannel";
import ExplanationTooltip from "./components/ExplanationTooltip";
import GameScoreInputs from "./components/GameScoreInputs";
import GridBackground from "./components/GridBackground";
import EventsList from "./components/EventsList";
import FadeModal from "./components/Modals/FadeModal";
import FilterBar from "./components/FilterBar";
import FilterCategory from './components/FilterCategory';
import FilterModal from "./components/Modals/FilterModal";
import Filters from "./components/Filters";
import FiltersPanel from './components/FiltersPanel';
import FullScreenModal from "./components/Modals/FullScreenModal";
import HeatMapFilters from "./components/HeatMapFilters/HeatMapFilters";
import HighlightPlayer from "./components/VideoPlayers/HighlightPlayer";
import HighlightPreview from "./components/HighlightPreview";
import HorizontalSeparator from './components/HorizontalSeparator';
import IconButton from './components/IconButton';
import ImageMarker from "./components/ImageMarker";
import InfoTable from './components/InfoTable';
import InfoTableAddRow from './components/InfoTableAddRow';
import InfoTile from './components/InfoTile';
import Input from "./components/UserInputs/Input";
import ImagePicker from "./components/ImagePicker";
import InnerPie from "./components/InnerPie";
import InviteUserModal from './components/Modals/InviteUserModal';
import KeepAspectRatio from './components/KeepAspectRatio';
import MediaObject from "./components/MediaObject/MediaObject";
import MemberDetails from './components/MemberDetails/MemberDetails';
import LineProgressBar from "./components/ProgressBars/LineProgressBar";
import LinkWithButton from "./components/LinkWithButton";
import LiveError from "./components/LiveError";
import LivePlayer from "./components/VideoPlayers/LivePlayer"
import Loader from "./components/Loaders/Loader";
import MainPie from "./components/MainPie";
import MyPlayLoader from './components/MyPlayLoader';
import NextStepModal from "./components/Modals/NextStepModal";
import NoEventsList from "./components/NoEventsList";
import NotifyContext from "./components/Notifyer/context";
import NotificationsContainer from './components/Notifications';
import NotificationsIcon from "./components/Notifications/NotificationsIcon";
import Notifyer from "./components/Notifyer";
import PieChart from "./components/PieChart";
import PlayerBadge from "./components/PlayerBadge";
import PlayerProfilePreview from "./components/PlayerProfilePreview";
import PlayerTooltip from './components/PlayerTooltip';
import PlayerTotalPoints from './components/PlayerTotalPoints';
import PlusButton from "./components/Buttons/PlusButton";
import PrimaryButton from "./components/Buttons/PrimaryButton";
import RangeDatePicker from './components/RangeDatePicker';
import Radio from "./components/Radio";
import RecordSchedulerPanel from './components/RecordSchedulerPanel';
import RefreshTeamCode from './components/RefreshTeamCode';
import RemovePlayerFromTeamModal from './components/Modals/RemovePlayerFromTeamModal';
import RoundCheckbox from "./components/UserInputs/RoundCheckbox";
import SaveModal from "./components/Modals/SaveModal";
import ScoreboardPositionPicker from "./components/ScoreboardPositionPicker";
import ScoreboardSettings from './components/Modals/ScoreboardSettings';
import ScoreboardTeamEdit from "./components/ScoreboardTeamEdit";
import SelectPlayerButton from "./components/Buttons/SelectPlayerButton";
import SelectTagButton from "./components/Buttons/SelectTagButton";
import SeparatorWithTitle from './components/SeparatorWithTitle';
import ShareVideoModal from './components/Modals/ShareVideoModal';
import SocialSharePanel from "./components/SocialSharePanel";
import SponsorUpload from "./components/UserInputs/SponsorUpload";
import StatsGameScore from "./components/StatsGameScore";
import StatsPreview from './components/StatsPreview';
import StatsTable from "./components/StatsTable";
import StatsTableHeader from './components/StatsTableHeader';
import StatsTablePlayer from './components/StatsTablePlayer';
import StatsTableContent from './components/StatsTableContent';
import SuccessButton from "./components/Buttons/SuccessButton";
import SwipeableViews from "./components/SwipeableViews";
import SwitchButton from "./components/Buttons/SwitchButton";
import Switch from "./components/Switch";
import SwitchButtonWithLabels from "./components/Buttons/SwitchButtonWithLabels";
import SwitchClubModal from "./components/Modals/SwitchClubModal";
import TableNameAvatarCell from './components/TableNameAvatarCell';
import TagsContainer from "./components/TagsContainer";
import TextInput from "./components/UserInputs/TextInput";
import TitleWithIcon from "./components/Titles/TitleWithIcon";
import TeamBrand from "./components/TeamBrand";
import TeamMembersSwiper from "./components/TeamMembersSwiper";
import TeamsListModal from './components/Modals/TeamsListModal';
import UploadVideoSkeleton from './components/UploadVideoSkeleton';
import VideoInfoBox from "./components/VideoInfoBox";
import VideoPlayer from "./components/VideoPlayers/VideoPlayer";
import VideoPlayerWithConnector from "./components/VideoPlayers/VideoPlayerWithConnector";
import VideoPreview from "./components/VideoPreview";
import VideosGrid from "./components/VideosGrid";
import WithLoader from "./components/WithLoader";
import WizardContainer from "./components/WizardContainer";
// import { NotificationsContainer, NotificationsIcon } from "./components/Notifications";

export {
  AddTextModal,
  Autocomplete,
  Bars,
  BreakdownsBottomPanel,
  Carousel,
  CategoryLoader,
  ComparisonTable,
  Checkbox,
  CircleProgressBar,
  ConfirmModal,
  ConnectWithFacebook,
  Counter,
  ClickOutside,
  CustomPie,
  DatePicker,
  DetailInput,
  DesktopFilterModal,
  DismissButton,
  EmptyHighlights,
  EmptyPlayerProfile,
  EmptyTeamChannel,
  EventsList,
  GridBackground,
  FadeModal,
  FilterBar,
  FilterCategory,
  FilterModal,
  Filters,
  FiltersPanel,
  FullScreenModal,
  HighlightPlayer,
  HorizontalSeparator,
  ImageMarker,
  ImagePicker,
  InnerPie,
  MediaObject,
  LineProgressBar,
  LivePlayer,
  Loader,
  NextStepModal,
  NoEventsList,
  NotifyContext,
  Notifyer,
  PlayerBadge,
  PlayerProfilePreview,
  PlusButton,
  PrimaryButton,
  SaveModal,
  SelectPlayerButton,
  SelectTagButton,
  SocialSharePanel,
  SuccessButton,
  SwipeableViews,
  SwitchButton,
  SwitchButtonWithLabels,
  TagsContainer,
  TextInput,
  Input,
  TitleWithIcon,
  TeamBrand,
  VideoInfoBox,
  VideoPlayer,
  VideoPlayerWithConnector,
  VideosGrid,
  WithLoader,
  WizardContainer,
  ToastContainer,
  toast,
  TeamMembersSwiper,
  PieChart,
  MainPie,
  StatsGameScore,
  HeatMapFilters,
  StatsTable,
  StatsTableHeader,
  StatsTablePlayer,
  StatsTableContent,
  PlayerTooltip,
  PlayerTotalPoints,
  SeparatorWithTitle,
  MyPlayLoader,
  GameScoreInputs,
  EditHighlightHeader,
  InfoTile,
  IconButton,
  DarkScreenMask,
  RoundCheckbox,
  CoachTile,
  KeepAspectRatio,
  StatsPreview,
  TableNameAvatarCell,
  InfoTable,
  InfoTableAddRow,
  CustomAutocomplete,
  Dropdown,
  RecordSchedulerPanel,
  InviteUserModal,
  AddPlayerToTeamModal,
  VideoPreview,
  Dots,
  BackButtonArrow,
  DotLoader,
  ShareVideoModal,
  DeleteVideoModal,
  DownloadVideoModal,
  AssignAssistantModal,
  MemberDetails,
  RemovePlayerFromTeamModal,
  DynamicPlayerBadge,
  TeamsListModal,
  RangeDatePicker,
  RefreshTeamCode,
  HighlightPreview,
  UploadVideoSkeleton,
  SwitchClubModal,
  NotificationsContainer,
  NotificationsIcon,
  ScoreboardSettings,
  DropdownWrapper,
  LinkWithButton,
  SponsorUpload,
  ScoreboardPositionPicker,
  ExplanationTooltip,
  ScoreboardTeamEdit,
  LiveError,
  Switch,
  Radio
};
